import { render, staticRenderFns } from "./CauseForm.vue?vue&type=template&id=433ffa2d&scoped=true&"
import script from "./CauseForm.vue?vue&type=script&lang=js&"
export * from "./CauseForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=433ffa2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ffa2d",
  null
  
)

export default component.exports